import withSimulatedLatency from '../../../lib/utils/with-simulated-latency';
import {
  Conversation,
  SendMessageRequest,
  StreamEvent,
} from '../../../models/assistant';
import AccountingApiClient from '../base-client';

const STREAM_EVENTS: string[] = ['delta', 'tool', 'done', 'error'];

class AssistantApi extends AccountingApiClient<Conversation> {
  public constructor() {
    super('/assistant/conversation');
  }

  public async getConversation(): Promise<Conversation> {
    return super.httpGet(this.baseUrl);
  }

  /** The answer as the backend writes it: text and tool progress, ending with the stored message. */
  public async *streamMessage(content: string): AsyncGenerator<StreamEvent> {
    const events = super.httpStream<SendMessageRequest>(
      `${this.baseUrl}/messages/stream`,
      { content }
    );

    yield* withSimulatedLatency(this.toStreamEvents(events));
  }

  private async *toStreamEvents(
    events: AsyncIterable<{ event: string; data: string }>
  ): AsyncGenerator<StreamEvent> {
    for await (const { event, data } of events) {
      if (this.isStreamEvent(event)) {
        yield { type: event, ...JSON.parse(data) };
      }
    }
  }

  private isStreamEvent(event: string): event is StreamEvent['type'] {
    return STREAM_EVENTS.includes(event);
  }

  public async restart(): Promise<void> {
    return super.httpPost<Record<string, never>, void>(
      `${this.baseUrl}/restart`,
      {}
    );
  }
}

const assistantApi = new AssistantApi();

export default assistantApi;
